import { Component, EventEmitter, Input, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { AppService } from '../../../core/services/app.service';
import { ToastrService } from 'ngx-toastr';
import { EventEmitterService } from '../../../core/services/event-emitter.service';
import { GlobalVariableService } from '../../../core/services/global-variable.service';
import { SharedDataService } from '../../../core/services/shared-data.service';
import { Subscription } from 'rxjs';
import { LocalStorageService } from 'ngx-webstorage';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoadingBarService } from '@ngx-loading-bar/core';

@Component({
  selector: 'app-solde',
  templateUrl: './solde.component.html',
  styleUrls: ['./solde.component.css']
})
export class SoldeComponent implements OnInit, OnDestroy {
  @Input() soldePropositions : any;
  public clickEventSubscription: Subscription;
  public detailsSoldeAM: any;
  public detailsSoldeIC: any;
  public detailsSoldeOE: any;
  public detailsSolde: any;
  public user: any;
  public userSlug: any;
  public response: any;
  public idStructure = 0
  constructor(
    private variable: GlobalVariableService, 
    private sharedService: SharedDataService, 
    private storage: LocalStorageService, 
    private _loader: LoadingBarService,
    private toastrService: ToastrService,
    private _service: AppService, 
    private eventEmitter: EventEmitterService, 
    private spinner: NgxSpinnerService,) {
    this.clickEventSubscription = this.sharedService.getClickEventRefreshTableSoldesProp().subscribe(() => {
      this.getMySolde();
    });
  }

  getMySolde() {
    this._loader.start();
    this._service.getData(`gestion-ofas/responsable-ofas/${this.storage.retrieve('idCampagneOfaSelected')}/mes-soldes`).subscribe( (res) => {
      this.response = res['data'];
      this._loader.stop();
      this.detailsSolde =  res['data'];
      this.detailsSoldeAM =  res['data']['AM'];
      this.detailsSoldeIC =  res['data']['IC'];
      this.detailsSoldeOE =  res['data']['OE'];
    }, (err) => {
      this._loader.stop();
      this.toastrService.error(err.error.message);
    });
  }

  ngOnInit() {
    this.user = JSON.parse(this.variable.getUser());
    this.userSlug = this.user?.profil?.slug;
    this.getMySolde();
  }

  public ngOnDestroy(): void {
    this.clickEventSubscription.unsubscribe();
  }

}
